import React from 'react';
import PropTypes from 'prop-types';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';

import BulkAction from './BulkAction';

const Edit = ({ children, ...props }) => (
  <BulkAction type='edit' icon={faPencil} title='Edit' menuTitle='Bulk Edits' {...props}>
    {React.Children.map(children, (child) => child && React.cloneElement(child, { ...props }))}
  </BulkAction>
);

Edit.propTypes = {
  children: PropTypes.node
};

Edit.defaultProps = {
  children: []
};

export default Edit;
